/* eslint-disable @typescript-eslint/no-explicit-any */
import { Form, Radio } from "antd";

export function FormRadioButtons({
  id,
  name = "",
  label,
  options,
  defaultValue,
  required,
  ...rest
}: any) {
  return (
    <Form.Item
      label={label}
      name={name}
      initialValue={defaultValue}
      rules={[
        {
          required: required,
          message: `Please select ${label.toLowerCase()}!`,
        },
      ]}
      layout="vertical"
    >
      <Radio.Group>
        {options?.map((option: any) => (
          <Radio key={option.value} value={option.value} {...rest}>
            {option.label}
          </Radio>
        ))}
      </Radio.Group>
    </Form.Item>
  );
}
